import dateFormat from 'dateformat';

export default function parseDateIntoHermesString(date: Date) {
  return dateFormat(date, 'yyyymmdd');
}
